import * as React from "react";

import { cn } from "@/lib/utils";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  isInvalid?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, isInvalid, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm placeholder:text-muted-foreground",
          "ring-1 ring-ring",
          "focus-visible:ring-primary-5 focus-visible:outline-hidden",
          "disabled:cursor-not-allowed disabled:opacity-50",
          "file:border-0 file:bg-transparent file:text-sm file:font-medium",
          "aria-invalid:ring-error aria-invalid:focus-visible:ring-error",
          className,
        )}
        ref={ref}
        aria-invalid={isInvalid}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
